import { Faq16, Tooltip } from '@cian/ui-kit';

import classNames from 'classnames';
import React, { FC, useMemo } from 'react';

import * as styles from './CheckboxLabel.css';
import { ICheckboxLabelProps } from './types';

export const CheckboxLabel: FC<ICheckboxLabelProps> = props => {
  const { label, postfixType, tooltipTitle } = props;

  const postfixView = useMemo(() => {
    switch (postfixType) {
      case 'new':
        return <span className={classNames(styles['postfix'], styles['postfix-new'])}>Новое</span>;

      case 'soon':
        return <span className={classNames(styles['postfix'], styles['postfix-soon'])}>Скоро</span>;

      case 'info':
        return (
          <Tooltip placement="top" title={tooltipTitle}>
            <span className={styles['postfix-info']}>
              <Faq16 color="primary_10" />
            </span>
          </Tooltip>
        );

      default:
        return null;
    }
  }, [postfixType, tooltipTitle]);

  return (
    <div className={styles['container']}>
      <span className={styles['label']}>{label}</span>
      {postfixView}
    </div>
  );
};
